export default defineNuxtPlugin(() => {
  if (process.client) {
    // Специальный плагин для исправления tooltip accessibility
    const fixTooltipAccessibility = () => {
      // Находим все tooltip элементы
      const tooltipElements = document.querySelectorAll('.ui-tooltip_trigger')
      
      tooltipElements.forEach((element, index) => {
        // Проверяем есть ли уже aria-label
        if (!element.hasAttribute('aria-label') && !element.hasAttribute('aria-labelledby')) {
          
          // Пытаемся найти текст tooltip разными способами
          let tooltipText = ''
          
          // 1. Проверяем data-атрибуты
          const dataTooltip = element.getAttribute('data-tooltip')
          if (dataTooltip) {
            tooltipText = dataTooltip
          }
          
          // 2. Проверяем title атрибут
          const titleAttr = element.getAttribute('title')
          if (titleAttr && !tooltipText) {
            tooltipText = titleAttr
          }
          
          // 3. Ищем связанный tooltip контент
          const tooltipId = element.getAttribute('aria-describedby')
          if (tooltipId && !tooltipText) {
            const tooltipContent = document.getElementById(tooltipId)
            if (tooltipContent) {
              tooltipText = tooltipContent.textContent?.trim() || ''
            }
          }
          
          // 4. Ищем ближайший tooltip контейнер
          if (!tooltipText) {
            const tooltipContainer = element.closest('[data-tooltip], .tooltip, .ui-tooltip')
            if (tooltipContainer) {
              tooltipText = tooltipContainer.getAttribute('data-tooltip') || 
                           tooltipContainer.textContent?.trim() || ''
            }
          }
          
          // 5. Fallback - используем содержимое элемента
          if (!tooltipText) {
            tooltipText = element.textContent?.trim() || `Tooltip ${index + 1}`
          }
          
          // Устанавливаем aria-label
          element.setAttribute('aria-label', tooltipText)
          
          // Добавляем role если его нет
          if (!element.hasAttribute('role')) {
            element.setAttribute('role', 'button')
          }
          
          // Устанавливаем tabindex для клавиатурной навигации
          if (!element.hasAttribute('tabindex')) {
            element.setAttribute('tabindex', '0')
          }
          
          // Убираем title чтобы избежать дублирования с aria-label
          if (element.hasAttribute('title')) {
            element.removeAttribute('title')
          }
        }
      })
    }
    
    // Запускаем сразу
    fixTooltipAccessibility()
    
    // Запускаем при изменениях DOM
    const observer = new MutationObserver(() => {
      setTimeout(fixTooltipAccessibility, 100) // Небольшая задержка для стабильности
    })
    
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'data-tooltip', 'title']
    })
    
    // Также запускаем при загрузке страницы
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fixTooltipAccessibility)
    } else {
      fixTooltipAccessibility()
    }
  }
})
